/**
 * API Configuration
 * Centraliza todas las URLs del backend
 */

// Base URL del API
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

// Endpoints del API
export const API_ENDPOINTS = {
  // Auth
  AUTH: {
    LOGIN: `${API_URL}/login`,
    REGISTER: `${API_URL}/register`,
    LOGOUT: `${API_URL}/logout`,
    USER: `${API_URL}/user`,
  },

  // Empresas
  EMPRESAS: `${API_URL}/empresas`,
  EMPRESA: (id) => `${API_URL}/empresa/${id}`,
  EMPRESA_CARPETA: (id) => `${API_URL}/empresa/carpeta/${id}`,

  // Usuarios
  USUARIOS: `${API_URL}/usuarios`,
  USUARIO: (id) => `${API_URL}/usuario/${id}`,
  USUARIO_FIND_ROL: `${API_URL}/usuario/find/rol`,

  // Roles
  ROLES: `${API_URL}/roles`,
  ROL: (id) => `${API_URL}/rol/${id}`,

  // Sucursales
  SUCURSALES: `${API_URL}/sucursales`,
  SUCURSAL: (id) => `${API_URL}/sucursal/${id}`,

  // Categorias
  CATEGORIAS: `${API_URL}/categorias`,
  CATEGORIA: (id) => `${API_URL}/categoria/${id}`,

  // Almacenes
  ALMACENES: `${API_URL}/almacenes`,
  ALMACEN: (id) => `${API_URL}/almacen/${id}`,

  // Movimientos
  MOVIMIENTOS: `${API_URL}/movimientos`,
  MOVIMIENTO: (id) => `${API_URL}/movimiento/${id}`,

  // Inventario section (Sub-endpoints)
  INVENTARIO: {
    GENERAL: `${API_URL}/inventario`,
    ITEM: (id) => `${API_URL}/inventario/${id}`,
    ESTADISTICAS: `${API_URL}/inventario/estadisticas`,
    AJUSTES: `${API_URL}/inventario/ajustes`,
    MOVIMIENTOS_CHART: `${API_URL}/inventario/movimientos-chart`,
    VALOR_CATEGORIA: `${API_URL}/inventario/valor-por-categoria`,
    STOCK_BAJO: `${API_URL}/inventario/stock-bajo`,
    VALOR_POR_ALMACEN: `${API_URL}/inventario/valor-por-almacen`,
    TRANSFERENCIAS: `${API_URL}/inventario/transferencias`,
    TRANSFERENCIA: (id) => `${API_URL}/inventario/transferencias/${id}`,
  },

  // Productos
  PRODUCTOS: `${API_URL}/productos`,
  PRODUCTO: (id) => `${API_URL}/productos/${id}`,
  PRODUCTO_AJUSTAR_STOCK: (id) => `${API_URL}/productos/${id}/ajustar-stock`,
  PRODUCTO_DETALLES: (id) => `${API_URL}/productos/${id}/detalles`,

  // Clientes
  CLIENTES: `${API_URL}/clientes`,
  CLIENTE: (id) => `${API_URL}/clientes/${id}`,

  // Ventas
  VENTAS: `${API_URL}/ventas`,
  VENTA: (id) => `${API_URL}/venta/${id}`,
  VENTAS_REPORTE: `${API_URL}/ventas/reporte`,
  VENTAS_PRODUCTOS_POPULARES: `${API_URL}/ventas/productos-populares`,

  // Métodos de Pago
  METODOS_PAGO: `${API_URL}/metodos-pago`,

  // Proveedores
  PROVEEDORES: `${API_URL}/proveedores`,
  PROVEEDOR: (id) => `${API_URL}/proveedor/${id}`,

  // Compras
  COMPRAS: `${API_URL}/compras`,
  COMPRA: (id) => `${API_URL}/compra/${id}`,
  COMPRAS_PENDIENTES: `${API_URL}/compras/pendientes`,

  // Cotizaciones
  COTIZACIONES: `${API_URL}/cotizaciones`,
  COTIZACION: (id) => `${API_URL}/cotizacion/${id}`,

  // Recepciones
  RECEPCIONES: `${API_URL}/recepciones`,
  RECEPCION: (id) => `${API_URL}/recepcion/${id}`,

  // Auditoría (Logs)
  AUDITORIA: {
    LOGS: `${API_URL}/audit-logs`,
    EXPORT: `${API_URL}/audit-logs/export`,
    LIMPIAR: `${API_URL}/audit-logs/cleanup`,
  },

  // Contabilidad
  CONTABILIDAD: {
    DASHBOARD: `${API_URL}/contabilidad/dashboard`,
    CUENTAS: `${API_URL}/contabilidad/cuentas`,
    CUENTA: (id) => `${API_URL}/contabilidad/cuentas/${id}`,
    ASIENTOS: `${API_URL}/contabilidad/asientos`,
    ASIENTO: (id) => `${API_URL}/contabilidad/asientos/${id}`,
    LIBRO_MAYOR: `${API_URL}/contabilidad/libro-mayor`,
    BALANCE_GENERAL: `${API_URL}/contabilidad/balance-general`,
    ESTADO_RESULTADOS: `${API_URL}/contabilidad/estado-resultados`,
    FLUJO_CAJA: `${API_URL}/contabilidad/flujo-caja`,
    REPORTES: `${API_URL}/contabilidad/reportes`,
  },

  // Recursos Humanos
  RRHH: {
    DASHBOARD: `${API_URL}/rrhh/dashboard`,
    EMPLEADOS: `${API_URL}/rrhh/empleados`,
    NOMINA: `${API_URL}/rrhh/nomina`,
    ASISTENCIAS: `${API_URL}/rrhh/asistencias`,
    VACACIONES: `${API_URL}/rrhh/vacaciones`,
    EVALUACIONES: `${API_URL}/rrhh/evaluaciones`,
    CAPACITACIONES: `${API_URL}/rrhh/capacitaciones`,
    DOCUMENTOS: `${API_URL}/rrhh/documentos`,
  },

  // Logistica
  LOGISTICA: {
    DASHBOARD: `${API_URL}/logistica/dashboard`,
    RUTAS: `${API_URL}/logistica/rutas`,
    FLOTAS: `${API_URL}/logistica/flotas`,
    CONDUCTORES: `${API_URL}/logistica/conductores`,
    ORDENES: `${API_URL}/logistica/ordenes`,
    ZONAS: `${API_URL}/logistica/zonas`,
    REPORTES: `${API_URL}/logistica/reportes`,
  },

  // Reportes
  REPORTES: {
    DASHBOARD_GENERAL: `${API_URL}/reportes/dashboard-general`,
    VENTAS_OPERATIVO: `${API_URL}/reportes/ventas-operativo`,
    INVENTARIO_OPERATIVO: `${API_URL}/reportes/inventario-operativo`,
    COMPARATIVO: `${API_URL}/reportes/comparativo`,
    INDICADORES: `${API_URL}/reportes/indicadores`,
    FINANCIEROS: `${API_URL}/reportes/financieros`,
    COMPRAS: `${API_URL}/reportes/compras-report`,
  },
};

export default API_ENDPOINTS;
